import { Viewport } from '@xyflow/react'
import { create } from 'zustand'

/**
 * Store for storing user local settings including viewport, available AI Q&P identifiers, and model identifiers.
 */
interface UserLocalSettingsStore {
  viewportSettings: Viewport
  setViewportSettings: (viewportSettings: Viewport) => void
  availableAIQandPIdentifiers: string[]
  setAvailableAIQandPIdentifiers: (identifiers: string[]) => void
  loadingAvailableAIQandPIds: boolean
  setLoadingAvailableAIQandPIds: (loading: boolean) => void
  availableModelIdentifiers: string[]
  setAvailableModelIdentifiers: (identifiers: string[]) => void
  loadingAvailableModelIdentifiers: boolean
  setLoadingAvailableModelIdentifiers: (loading: boolean) => void
  processingItems: string[]
  setProcessingItems: (items: string[]) => void
}

const useUserLocalSettingsStore = create<UserLocalSettingsStore>((set) => ({
  viewportSettings: {
    x: 0,
    y: 0,
    zoom: 1,
  },
  setViewportSettings: (viewportSettings: Viewport) => {
    set({ viewportSettings })
  },
  availableAIQandPIdentifiers: [],
  setAvailableAIQandPIdentifiers: (identifiers: string[]) => {
    set({ availableAIQandPIdentifiers: identifiers })
  },
  loadingAvailableAIQandPIds: false,
  setLoadingAvailableAIQandPIds: (loading: boolean) => {
    set({ loadingAvailableAIQandPIds: loading })
  },
  availableModelIdentifiers: [],
  setAvailableModelIdentifiers: (identifiers: string[]) => {
    set({ availableModelIdentifiers: identifiers })
  },
  loadingAvailableModelIdentifiers: false,
  setLoadingAvailableModelIdentifiers: (loading: boolean) => {
    set({ loadingAvailableModelIdentifiers: loading })
  },
  processingItems: [],
  setProcessingItems: (items: string[]) => {
    set({ processingItems: items })
  },
}))

export default useUserLocalSettingsStore
